import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Globals } from '../objects/Globals';
import { EnvService } from '../env.service';

@Injectable({
  providedIn: 'root'
})
export class JobService {
  private serviceUrl:string;
  constructor(private http:HttpClient, private globals:Globals, private env: EnvService) { 
    this.serviceUrl = this.env.servicePath; 
  }

  createJobList(jobType:string):Observable<string>{
    var path = this.serviceUrl +"CreateJobListCard/"+ jobType;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, '', httpOptions);
  }

  getJobList(id:string):Observable<string>{
    var path = this.serviceUrl +"GetJobListCard/"+ id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  triggerJob(id:string, jobId:string):Observable<string>{
    var path = this.serviceUrl +"TriggerJob/"+ id + "/" + jobId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, '', httpOptions);
  }
}
